import findIndex from 'lodash/findIndex'
import Moment from 'moment'
import * as Redux from 'redux'
import * as DateSelector from '../../components/date-selector'
import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const normalizeTypes = (payload: Types.TrainingDataState): Types.TrainingDataState =>
  payload.map((lp: Types.TrainingPost) => ({
    ...lp,
    created_datetime: Moment(lp.created),
  }))

const emptyViewState: Types.TrainingViewState = {
  dateSelect: Constants.DATE_SELECT_LAST_NEWSBRIEF,
  end: null,
  filter: Constants.UNTRAINED_FILTER,
  isLoading: false,
  sort: [],
  start: Moment().format('YYYY-MM-DD'),
}

type AllActions = Redux.Action &
                  Request.SuccessAction &
                  DateSelector.SelectDateAction &
                  IsActive.FilterActionObject &
                  DateSelector.SelectDateRangeAndFilterAction

export const viewReducer = (state: Types.TrainingViewState = emptyViewState, action: AllActions) => {
  switch (action.type) {
    case Constants.INITIALIZE_DATE:
      return {
        ...state,
        end: action.end,
        start: action.start,
      }
    case Request.requestConstant(Constants.FETCH_TRAINING_CONTENT):
      return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(Constants.FETCH_TRAINING_CONTENT):
    case Request.errorConstant(Constants.FETCH_TRAINING_CONTENT):
      return {
        ...state,
        isLoading: false,
      }
    case Constants.SELECT_TRAINING_DATE_RANGE:
      return {
        ...state,
        end: action.end,
        start: action.start,
      }
    case Constants.SELECT_TRAINING_DATE_RANGE_AND_FILTER:
      return {
        ...state,
        dateSelect: action.dateSelect,
        end: action.end,
        filter: action.filter,
        start: action.start,
      }
    case IsActive.filterStatusConstant(Constants.FETCH_TRAINING_CONTENT):
      return {
        ...state,
        filter: action.filter,
      }
    case IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT):
      return {
        ...state,
        dateSelect: action.filter,
      }
    default:
      return state
  }
}

const emptyDataState: Types.TrainingDataState = []

const doSetPostCategory = (state: Types.TrainingDataState, payload: any, isReset: boolean) => {
  const rowIndex: number = findIndex(state, (p: Types.TrainingPost) => p.id === payload.id)
  return [
    ...state.slice(0, rowIndex),
    {
      ...state[rowIndex],
      category: isReset ? state[rowIndex].oldCategory : payload.category,
      oldCategory: isReset ? null : state[rowIndex].category,
    },
    ...state.slice(rowIndex + 1),
  ]
}

const resetPostCategory = (state: Types.TrainingDataState, payload: any) => doSetPostCategory(state, payload, true)
const setPostCategory = (state: Types.TrainingDataState, payload: any) => doSetPostCategory(state, payload, false)

const dataReducer = (
  state: Types.TrainingDataState = emptyDataState,
  action: Actions.TrainPostAction & Request.SuccessAction,
) => {
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_TRAINING_CONTENT):
      return []
    case Request.successConstant(Constants.FETCH_TRAINING_CONTENT):
      return normalizeTypes(action.payload.response.posts)
    case Request.requestConstant(Constants.TRAIN_POST):
      return setPostCategory(state, action.options.payload)
    case Request.errorConstant(Constants.TRAIN_POST):
      return resetPostCategory(state, action.requestAction.options.payload)
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/training/reducer.ts